<section class="voice-purchase-request-recorder flex min-h-0 flex-1 flex-col overflow-hidden">
  <div
    class="voice-purchase-request-recorder__scroll flex min-h-0 flex-1 flex-col gap-4 overscroll-y-contain px-1 pb-2"
    [class.voice-purchase-request-recorder__scroll--finished]="phase() === 'finished'"
    [class.voice-purchase-request-recorder__scroll--recording]="phase() === 'recording'"
  >
    @if (contextLabel(); as label) {
      <p class="shrink-0 text-center text-xs font-medium uppercase tracking-wide text-[#7a6b8a]">
        {{ label }}
      </p>
    }

    @if (phase() === "recording") {
      <div
        class="flex shrink-0 items-center justify-between gap-3 rounded-xl border border-[#ece4f3] bg-[#faf7fc] px-4 py-2"
      >
        <p class="text-xs font-medium text-[#7a6b8a]">{{ "mobile.voiceReport.recorder.recordingHint" | translate }}</p>
        <p class="font-mono text-sm font-semibold tabular-nums text-[#5a2f6b]" aria-live="polite">
          {{ formatElapsed() }}
        </p>
      </div>
    } @else if (phase() === "finished") {
      <p class="shrink-0 rounded-xl border border-[#ece4f3] bg-[#faf7fc] px-4 py-2 text-center text-xs text-[#7a6b8a]">
        {{ "mobile.voicePurchaseRequest.recorder.finishedHint" | translate }}
      </p>
    } @else {
      <article
        class="flex shrink-0 flex-col items-center justify-center gap-4 rounded-2xl border border-[#ece4f3] bg-[#faf7fc] px-5 py-6 text-center"
      >
        <span
          class="inline-flex h-16 w-16 items-center justify-center rounded-full bg-white text-[#5a2f6b] shadow-sm"
          aria-hidden="true"
        >
          <span class="material-icons text-[36px]">mic</span>
        </span>

        <div class="max-w-sm space-y-2">
          <p class="text-sm font-semibold text-[#3d2652]">
            {{ infoTitleKey() | translate }}
          </p>
          <p class="text-xs leading-relaxed text-[#7a6b8a]">
            {{ infoBodyKey() | translate }}
          </p>
        </div>

        @if (micDenied()) {
          <p class="text-xs text-destructive">{{ "mobile.voiceReport.recorder.error.micDenied" | translate }}</p>
        }
      </article>
    }

    @if (showTranscriptBlock()) {
      <div
        class="flex min-h-0 flex-col gap-2"
        [class.voice-purchase-request-transcript-block--finished]="phase() === 'finished'"
        [class.voice-purchase-request-transcript-block--recording]="phase() === 'recording'"
      >
        <label class="shrink-0 text-xs font-medium text-[#7a6b8a]" for="voice-purchase-request-transcript">
          {{ "mobile.voicePurchaseRequest.recorder.transcriptLabel" | translate }}
        </label>
        <div
          class="voice-purchase-request-transcript-scroll min-h-0"
          [class.voice-purchase-request-transcript-scroll--finished]="phase() === 'finished'"
          [class.voice-purchase-request-transcript-scroll--recording]="phase() === 'recording'"
        >
          <textarea
            #transcriptArea
            id="voice-purchase-request-transcript"
            class="voice-purchase-request-transcript-area w-full resize-none px-4 py-3 text-sm leading-relaxed text-[#3d2652] outline-none focus:border-[#5a2f6b] focus:ring-1 focus:ring-[#5a2f6b]/30"
            rows="1"
            aria-live="polite"
            [readOnly]="phase() === 'recording' || !isEditing()"
            [placeholder]="phase() === 'finished' ? '' : ('mobile.voicePurchaseRequest.recorder.transcriptPlaceholder' | translate)"
            [ngModel]="transcript()"
            (ngModelChange)="onTranscriptModelChange($event)"
          ></textarea>
        </div>
      </div>
    }
  </div>

  <footer class="voice-purchase-request-recorder__actions shrink-0 border-t border-[#ece4f3] bg-background px-1 pb-2 pt-3">
    @if (phase() === "finished") {
      <div class="flex gap-2">
        <button
          type="button"
          class="flex min-h-[3rem] flex-1 items-center justify-center gap-2 rounded-xl border border-[#ece4f3] bg-white px-4 py-3 text-sm font-semibold text-[#5a2f6b] shadow-sm active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60"
          [disabled]="!transcript().trim()"
          (click)="onModify()"
        >
          <span class="material-icons text-[20px]" aria-hidden="true">edit</span>
          {{ "mobile.voicePurchaseRequest.recorder.edit" | translate }}
        </button>
        <button
          type="button"
          class="flex min-h-[3rem] flex-1 items-center justify-center gap-2 rounded-xl bg-[#5a2f6b] px-4 py-3 text-sm font-semibold text-white shadow-sm active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60"
          [disabled]="!transcript().trim()"
          (click)="onSend()"
        >
          <span class="material-icons text-[20px]" aria-hidden="true">send</span>
          {{ "mobile.voicePurchaseRequest.recorder.send" | translate }}
        </button>
      </div>
    } @else {
      <button
        type="button"
        class="flex min-h-[3rem] w-full items-center justify-center gap-2 rounded-xl bg-[#5a2f6b] px-4 py-3 text-sm font-semibold text-white shadow-sm active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60"
        [disabled]="micDenied()"
        (click)="onPrimaryAction()"
      >
        <span class="material-icons text-[22px]" aria-hidden="true">{{ primaryIcon() }}</span>
        {{ primaryLabelKey() | translate }}
      </button>
    }
  </footer>
</section>
